import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import cr1 from '../assets/carousel/cr-1.jpg';
import cr2 from '../assets/carousel/cr-2.jpg';
import cr3 from '../assets/carousel/cr-3.jpg';
import cr4 from '../assets/carousel/cr-4.jpg';

interface SlideData {
    id: number;
    image: string;
    smallText: string;
    mainText: string;
}

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [key, setKey] = useState(0); // Key to restart Ken Burns animation

    const slides: SlideData[] = [
        {
            id: 1,
            image: cr1,
            smallText: 'TRUSTED SINCE 1998',
            mainText: 'Confident Early Learning'
        },
        {
            id: 2,
            image: cr2,
            smallText: 'SAFE & NURTURING',
            mainText: 'Confident Early Learning'
        },
        {
            id: 3,
            image: cr4,
            smallText: 'LEARNING THROUGH PLAY',
            mainText: 'Play-Based Growth'
        },
        {
            id: 4,
            image: cr3,
            smallText: 'EVERY CHILD MATTERS',
            mainText: 'Personalised Child Development'
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        arrows: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true,
                    speed: 1000,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: true,
                    speed: 1000,
                }
            }
        ],
        beforeChange: (current: number, next: number) => {
            setCurrentSlide(next);
            setKey(prev => prev + 1); // Restart Ken Burns animation
        },
        customPaging: (i: number) => (
            <div className={`hero-dot ${i === currentSlide ? 'active' : ''}`}></div>
        )
    };

    return (
        <section id="home" className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[1000px] overflow-hidden">
            <Slider {...settings} className="hero-slider h-full">
                {slides.map((slide) => (
                    <div key={slide.id} className="relative w-full h-full">
                        <div className="ken-burns-container">
                            <img 
                                key={`${slide.id}-${key}`}
                                src={slide.image} 
                                alt={slide.smallText}
                                className="ken-burns-image"
                            />
                        </div>
                        {/* Warm brown/orange overlay filter */}
                        <div className="absolute inset-0 bg-gradient-to-b from-amber-900/45 via-orange-800/30 to-amber-800/50 sm:from-amber-900/40 sm:via-orange-800/25 sm:to-amber-800/45 z-0"></div>
                        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/35 to-black/45 sm:from-black/20 sm:via-black/30 sm:to-black/40 flex items-center justify-center z-10">
                            <div className="text-center px-4 sm:px-6 md:px-8 z-10 max-w-4xl w-full">
                                <p className="text-white text-[10px] sm:text-xs md:text-sm uppercase tracking-[0.15em] sm:tracking-[0.2em] mb-2 sm:mb-3 md:mb-4 font-secondary opacity-90 font-semibold">
                                    {slide.smallText}
                                </p>
                                <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold font-secondary leading-tight px-2 sm:px-0">
                                    {slide.mainText}
                                </h1>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default Hero;